module.exports = __webpack_public_path__ + "static/media/Icon-moon.0a7902bd.svg";